import React from 'react';
import PropTypes from 'prop-types';
import { SimpleImagePreview } from '@bingads-webui-campaign-react/upload-file-picker';

export const FileUploadingPreview = ({
  className,
  url,
  isVideo,
  alt,
}) => {
  if (isVideo) {
    // eslint-disable-next-line jsx-a11y/media-has-caption
    return <video className={className} src={url} />;
  }

  return <SimpleImagePreview className={className} url={url} alt={alt} />;
};

FileUploadingPreview.propTypes = {
  className: PropTypes.string,
  url: PropTypes.string.isRequired,
  isVideo: PropTypes.bool,
  alt: PropTypes.string,
};

FileUploadingPreview.defaultProps = {
  className: '',
  isVideo: false,
  alt: '',
};
